import React, { useState } from 'react';
import axios from 'axios';

const Form = () => {
  const [formData, setFormData] = useState({
    date: '',
    title: '',
    text: '',
    content: '',
    prayer: '',
    bible_reading: '',
  });

  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    setError('');  // Clear any previous errors
    setSuccess('');  // Clear any previous success messages

    try {
      const response = await axios.post('https://cacityofgod.pythonanywhere.com/citizen/create_breakfastwiththeholyspirit/', formData);
      console.log('Registration successful:', response.data);
      setSuccess('Registration successful!');  // Set the success message
      setFormData({
        date: '',
        title: '',
        text: '',
        content: '',
        prayer: '',
        bible_reading: '',
      });  // Clear the form fields
    } catch (error) {
      setError(error.response?.data?.message || error.message || 'Registration failed.');
      console.error('Registration failed:', error);
    }
  };

  const handleChange = (e) => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      [e.target.name]: e.target.value,
    }));
  };

  return (
    <div className="w-full m-[24px]">
      <h2 className="text-2xl font-bold mb-4">Register</h2>
      <form onSubmit={handleSubmit}>
        <div className="mb-4">
          <label htmlFor="date" className="block font-medium mb-1">Date</label>
          <input
            type="text"
            id="date"
            name="date"
            value={formData.date}
            onChange={handleChange}
            placeholder="OCTOBER, MONDAY 1, 2024"
            className="w-full border border-gray-300 rounded-md py-2 px-3"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="title" className="block font-medium mb-1">Title</label>
          <input
            type="text"
            id="title"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-md py-2 px-3"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="text" className="block font-medium mb-1">Text</label>
          <input
            type="text"
            id="text"
            name="text"
            value={formData.text}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-md py-2 px-3"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="content" className="block font-medium mb-1">Content</label>
          <textarea
            id="content"
            name="content"
            value={formData.content}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-md py-2 px-3"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="prayer" className="block font-medium mb-1">Prayer</label>
          <textarea
            id="prayer"
            name="prayer"
            value={formData.prayer}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-md py-2 px-3"
          />
        </div>
        <div className="mb-4">
          <label htmlFor="bible_reading" className="block font-medium mb-1">Bible Reading</label>
          <input
            type="text"
            id="bible_reading"
            name="bible_reading"
            value={formData.bible_reading}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-md py-2 px-3"
          />
        </div>
        <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded-md">
          Register
        </button>
      </form>
      {error && <p className="text-red-500 text-sm mt-2">{error}</p>}
      {success && <p className="text-green-500 text-sm mt-2">{success}</p>}
    </div>
  );
};

export default Form;
